export default function isLength(value, range) {
  return !(
    (range[0] === undefined && range[1] && value.length > range[1]) ||
    (range[1] === undefined && range[0] && value.length < range[0]) ||
    (range[0] && value.length < range[0]) ||
    (range[1] && value.length > range[1])
  );
}
